import { fillPlot, level, levelRules, linePlot, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { FILL_BETWEEN_LEVELS, PRICE_SOURCE } from "../indicatorTypes";
import { priceReader } from "../math/priceSources";
import { smaAt } from "../math/movingAverages";
import { meanDeviationAt } from "../math/statistics";

// Lambert's constant: about 70-80% of the values fall between −100 and +100
const CCI_CONSTANT = 0.015;

// Levels typed in the Styles tab, as in PO
const CCI_LEVEL_LIMIT_MIN = -200;
const CCI_LEVEL_LIMIT_MAX = 200;

/**
 * CCI (research §1.4), as TV Commodity Channel Index: (hlc3 − its SMA) /
 * (0.015 × the mean deviation of hlc3), with a background between the levels.
 */
export default {
  id: "cci",
  name: "CCI",
  isOscillator: true,
  decimals: 2,
  inputs: [
    periodInput("period", "Period", 20, { max: 200 }),
  ],
  plots: [
    linePlot("value", "Main Line", PALETTE.YELLOW),
    fillPlot("background", "Background", PALETTE.YELLOW, FILL_BETWEEN_LEVELS),
  ],
  levels: [level(100, PALETTE.YELLOW), level(-100, PALETTE.YELLOW)],
  levelRules: levelRules(CCI_LEVEL_LIMIT_MIN, CCI_LEVEL_LIMIT_MAX),

  calculate: (bars, { period }, series, fromIndex) => {
    const read = priceReader(bars, PRICE_SOURCE.HLC3);

    for (let index = fromIndex; index < bars.length; index += 1) {
      const deviation = meanDeviationAt(read, index, period);

      series.value[index] = (read(index) - smaAt(read, index, period)) / (CCI_CONSTANT * deviation);
    }
  },
};
